/**
 * The disbursement options enum.
 */
export enum DisbursementOptionsEnum {
  UNKNOWN = 'Unknown',
  FULL = 'Full',
  PARTIAL = 'Partial'
}
